export const generalIconsList = {
  clipboard: {
    src: '/static/img/website/solutions/icons/clipboard.svg',
    alt: 'illustration of a clipboard'
  },
  gauge: {
    src: '/static/img/website/solutions/icons/gauge.svg',
    alt: 'illustration of a gauge'
  },
  graphWrench: {
    src: '/static/img/website/solutions/icons/graph-wrench.svg',
    alt: 'illustration of a graph wrench'
  },
  hexagon: {
    src: '/static/img/website/solutions/icons/hexagon.svg',
    alt: 'illustration of a hexagon'
  },
  technology: {
    src: '/static/img/website/solutions/icons/technology.svg',
    alt: 'illustration of a technology'
  },
  trefoil: {
    src: '/static/img/website/solutions/icons/trefoil.svg',
    alt: 'illustration of a trefoil'
  }
};
